import { render, staticRenderFns } from "./changePhoneNumber.vue?vue&type=template&id=40b26e0c&scoped=true"
import script from "./changePhoneNumber.vue?vue&type=script&lang=js"
export * from "./changePhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./changePhoneNumber.vue?vue&type=style&index=0&id=40b26e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b26e0c",
  null
  
)

export default component.exports